export enum InboundShareStatusEnum {
  NEW = "NEW",
  VIEWED = "VIEWED",
  ACCEPTED = "ACCEPTED",
  PENDING = "PENDING",
}
